import React, { useState, useEffect } from 'react'
import { MinSOCChart } from './MinSOCChart'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'
import { SearchCriteria, SearchCriteriaParams } from '@/pages/communal/statistics/components/common/searchCriteria'
import { mapBuckets } from '../common/labels'
import { HelpPopupButton } from '@/popups/helppopup/help'
import { useModal } from '@/components/modal/Modal'
import { MinSOCPopupBody } from './MinSOCPopup'

type MinSOCBoxProps = {
  services: Services
  session: CurrentSession
  criteria: SearchCriteria
  goToUserPage: (userId: string) => void
  goToMachinePage: (machineId: string) => void
}

// Interface representing a single data entry
export interface MinSOCData {
  bucket: string // ISO timestamp string
  hour: string     
  imei: number     // Device IMEI
  minSOC: number  // Minimum row value
}

// Interface representing the full API response (array of entries)
export type SOCDataResponse = MinSOCData[]


export const MinSOCBox = ({ services, session, criteria, goToUserPage, goToMachinePage }: MinSOCBoxProps) => {
  const translates = useTranslations(services, session)
  const [response, setResponse] = useState<SOCDataResponse>()
    const { openModal } = useModal()

  useEffect(() => {
    setResponse(undefined)
    services.session
      .fetchWithToken(`/api/communal/statistics/machines/soc_graph?${SearchCriteriaParams(criteria)}`)
      .then((r) => r.json())
      .then((data) => {
        setResponse(data)
      })
  }, [services.session, criteria])

  if (translates === undefined || !response) {
    return <div className='spinner'></div>
  }

  // Sort by hour or other logic if needed
  const labels = response.map(mapBuckets)
  const dataSet = response.map(row => row.minSOC)

  return (
    <div>
      <HelpPopupButton helpKey='page.dashboard.global.box.socmins.help' translates={translates} />
      <MinSOCChart labels={labels} dataSet={dataSet}
        chartTitle={translates.for('page.dashboard.global.box.socmins.title')}
        dataLabel={translates.for('page.dashboard.global.box.socmins.data_label')}
        onClick={(i: number) => {
          openModal((props) => MinSOCPopupBody({
            ...props,
            services,
            session,
            translates: translates,
            criteria: criteria,
            bucketFor: new Date(response[i].bucket),
            goToUserPage,
            goToMachinePage
          }))
        }} />
    </div>
  )
}
